import { useMemo } from 'react';
import { useIntl } from 'umi';
import useSearchParams from '@gp/hooks/useSearchParams';
import { getBasePath } from '@/utils/utils';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import { copyText } from '@intelligence/utils/common';
import type { IPDFPreviewDownloadLikeShareURLSearchParams } from '../types';
import { pageReportTypeConfig, NEW_PDF_PREVIEW_STYLE_REPORTS } from '@intelligence/pages/InsightsReport/_config';
import { setLikeInsightsReport } from '@intelligence/services/reportService';

interface IUseShareProps extends IPDFPreviewDownloadLikeShareURLSearchParams {
  setLikeBubble: React.Dispatch<React.SetStateAction<boolean>>;
  setShareBubble: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function useShare(props: IUseShareProps) {
  const {
    systemId,
    resourceId,
    setLikeBubble,
    setShareBubble,
    lang,
    reportObject,
    studioId,
  } = props;
  const { formatMessage } = useIntl();
  const { btnLogCfgCur, shareTypeCur } = reportObject || {};

  const { referer } = useSearchParams();

  const isStudioReport = useMemo(() => {
    return systemId === pageReportTypeConfig.studioReport.systemIdCur;
  }, [pageReportTypeConfig, systemId]);

  const handleShare = async () => {
    const name = formatMessage(
      { id: 'dbi_insight_report_share_success_tips2' },
      {
        type: formatMessage({ id: shareTypeCur }),
      },
    );
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('systemId', systemId);
    urlSearchParams.set('resourceId', resourceId);
    if (isStudioReport && studioId) {
      urlSearchParams.set('studioId', studioId);
    }
    if (systemId == 'gameResearch' || isStudioReport) {
      urlSearchParams.set('lang', `${lang}`);
    }
    if (systemId !== 'studio_report' && referer) {
      urlSearchParams.set('referer', referer);
    }

    const text = `${name} ${
      window.location.origin
    }${getBasePath()}/intelligence/pdfPreviewDownloadLikeShare?${urlSearchParams.toString()}`;

    copyText(text, {
      onSuccess: () => {
        const isNewStyleReport = NEW_PDF_PREVIEW_STYLE_REPORTS.includes(systemId);

        // 转发计数
        isNewStyleReport &&
          setLikeInsightsReport({
            system: systemId,
            resource_id: resourceId || '',
            action_type: 'forward',
          });

        const btnLogCfg = btnLogCfgCur;
        if (btnLogCfg) {
          btnLogCfg.extInfo = text;
          // 将新展示样式的报告，点赞埋点只传 resourceId
          if (isNewStyleReport) {
            btnLogCfg.extInfo = resourceId;
          }
          buriedBtnPoint(btnLogCfg);
        }
        setLikeBubble(false);
        setShareBubble(true);
        setTimeout(() => {
          setShareBubble(false);
        }, 4000);
      },
      onError: () => {},
    });
  };

  return {
    onShare: handleShare,
  };
}
